<template>
  <div>
    <div class="nav">
      <!-- 欢迎光临 start -->
      <div class="welcome">
        <div class="welcome-box">
          <p class="txt">您好，欢迎来到黑河市宏达职业技术培训学校 !</p>
          <div class="txt-link">
            <a href="javascript:;"  class="login-txt" v-if="headUserName == ''||headUserName == null" @click="changePop(1)">请登录</a>
            <span   class="login-txt"  v-if="headUserName != ''&&headUserName != null" >{{headUserName}}</span>
            <a href="javascript:;"  v-if="headUserName == ''||headUserName == null"  style="margin-left: 0;" @click="changePop(2)">注册有礼</a>
            <a href="javascript:;" v-if="headUserName != ''&&headUserName != null"  @click="logoutFun">退出登录</a>
            <a href="javascript:;" :class="navActive == 4? 'active':''"  @click="togoTel(4)">客服电话</a>
          </div>
        </div>
      </div>
      <!-- 欢迎光临 end -->
      <!-- 登录 注册 start -->
      <div class="mask" v-show="popul">
        <div class="wrapper">
          <div class="close_wrapper">
            <i class="close" @click="closePop()"><img src="../../static/images/zmr-images/close.png"/></i>
            <i class='back' v-if="logOrReg == 2" @click="changePop(1)"><img src="../../static/images/zmr-images/left_arrow.png"/></i>
          </div>
          <h3 class="title" v-if="logOrReg == 2">注册宏达职业技术培训学校</h3>
          <h3 class="title"  v-if="logOrReg == 1 || logOrReg == 3">登录宏达职业技术培训学校</h3>
          <div class="main">
            <!--密码登录1 start-->
            <div v-if="logOrReg == 1">
              <form @submit.prevent="loginFun">
                <div class="item">
                  <img src="../../static/images/zmr-images/user.png">
                  <input placeholder="请输入手机号" type="tel"  name="phone" oninput="this.value=this.value.replace(/\D/g,'')"
                         maxlength="11" v-model="registerInput.phone"/>
                </div>
                <div class="item">
                  <img src="../../static/images/zmr-images/lock.png">
                  <input placeholder="请输入密码" v-model="registerInput.loginPassword" type="password" name="loginPassword"/>
                </div>
                <div class="error_content" v-if="error_content">{{error_content}}</div>
                <button class="login_btn" type="submit">登录</button>
                <div class="other_btn">
                  <div @click="changePop(3)">手机验证码登录</div>
                  <div @click="changePop(2)">注册新账号</div>
                </div>
              </form>
            </div>
            <!--密码登录1 end-->
            <!--注册2 start-->
            <div v-if="logOrReg == 2">
              <form @submit.prevent="register">
                <div class="item">
                  <img src="../../static/images/zmr-images/phone_icon.png">
                  <input placeholder="请输入手机号" :class="{error_active:error_type == '1'}" type="tel" name="phone" v-model="registerInput.phone" @change="telInputFun"
                         oninput="this.value=this.value.replace(/\D/g,'')" maxlength="11"/>
                </div>

                <div class="item">
                  <img src="../../static/images/zmr-images/mail.png">
                  <input placeholder="请短信验证码" :class="{error_active:error_type == '2'}" name="code"
                         oninput="if(value.length>4) value=value.slice(0,4)" v-model="registerInput.code"/>
                  <div class="code_btn">
                    <span v-show="register_authCode.sendAuthCode" @click="getAuthCode(register_authCode,register_authCode.sendAuthCode)" class="high_light">获取验证码</span>
                    <p v-show="!register_authCode.sendAuthCode"><span class="auth_text_blue">{{register_authCode.auth_time}}</span> 秒后重新发送</p>
                  </div>
                </div>
                <div class="item">
                  <img src="../../static/images/zmr-images/lock.png">
                  <input placeholder="请输入密码(至少六位)" minlength="6" id="passwordNum" :class="{error_active:error_type == '4'}" name="password" v-model="registerInput.password"
                         type="password"/>
                </div>
                <div class="item">
                  <img src="../../static/images/zmr-images/lock.png">
                  <input placeholder="请再次输入密码" minlength="6" :class="{error_active:error_type == '5'}" name="passwordAgain"
                         v-model="registerInput.passwordAgain" @blur="checkPassword" @click="cleanError()"
                         type="password"/>
                </div>

                <div class="error_content" v-if="error_content">{{error_content}}</div>

                <div class="user_agreement">
                  <span>我接受并同意</span>
                  <a href="javascript:;" @click="toTerms(2)"  class='high_light'>《用户服务条款》</a>
                  <span style="color: #959595;">和</span>
                  <a href="javascript:;" @click="toTerms(3)"  class='high_light'>《隐私权相关政策》</a>                </div>
                <button class="login_btn" type="submit" value="提交">同意并注册</button>
              </form>
            </div>
            <!--注册2 end-->
            <!--验证码登录3 start-->
            <div v-if="logOrReg == 3">
              <form @submit.prevent="authCode_login">
                <div class="item">
                  <img src="../../static/images/zmr-images/phone_icon.png">
                  <input placeholder="请输入手机号" :class="{error_active:error_type == '1'}" type="tel" name="phone" v-model="registerInput.phone" @change="telInputFun"
                         oninput="this.value=this.value.replace(/\D/g,'')" maxlength="11"/>
                </div>
                <div class="item">
                  <img src="../../static/images/zmr-images/mail.png">
                  <input placeholder="请输入短信验证码" name='loginCode' v-model="registerInput.loginCode"
                         @click="cleanError" oninput="if(value.length>4) value=value.slice(0,4)"/>
                  <div class="code_btn">
                    <span class="high_light" v-show="login_authCode.sendAuthCode" @click="getAuthCode(login_authCode,login_authCode.sendAuthCode)" >获取验证码</span>
                    <p v-show="!login_authCode.sendAuthCode"> <span class="auth_text_blue">{{login_authCode.auth_time}} </span> 秒后重新发送</p>
                  </div>
                </div>
                <div class="error_content" v-if="error_content">{{error_content}}</div>
                <button class="login_btn" type="submit" value="提交">登录</button>
                <div class="other_btn">
                  <div @click="changePop(1)">密码登录</div>
                  <div @click="changePop(2)">注册新账号</div>
                </div>
              </form>
            </div>
            <!--验证码登录3 end-->
          </div>
        </div>
      </div>
      <!-- 登录 注册 end -->
      <!--头部导航 start -->
      <div class="city-search">
        <div class="logo"><img src="../../static/images/zmr-images/logo.png" width="100%"></div>
        <div class="city">
          <router-link to="/">
            <span :class="navActive == 0? 'active':''">首页</span>
          </router-link>
          <span @click="togoOnlineClass" :class="navActive == 1? 'active':''">线上课</span>
          <router-link to="/live-class">
            <span :class="navActive == 2? 'active':''">直播课</span>
          </router-link>
          <span @click="togoUser()" :class="navActive == 3? 'active':''">个人中心</span>
          <router-link to="/service">
            <span :class="navActive == 4? 'active':''">客服</span>
          </router-link>
          <router-link to="/aboutuser/brief">
            <span :class="navActive == 5? 'active':''">关于我们</span>
          </router-link>
          <!-- <router-link   to="/zs"> -->
            <span @click="togoUsers()"  :class="navActive == 6? 'active':''">证书下载</span>
          <!-- </router-link> -->
            <span  @click="go()"  :class="navActive == 7? 'active':''">考试系统</span>
        </div>
        <div class="search">
          <input type="text" placeholder="搜索课程" class="search-input" @keyup.enter="searchFun" v-model="searchName">
          <span class="reading_glass" @click="searchFun"><img src="../../static/images/zmr-images/reading_glass.png"></span>
        </div>
      </div>
      <!--头部导航 end -->
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
  import axios from 'axios'
  import tool from '../assets/js/tool'
  export default {
    name: 'welcomeNav',
    data: function () {
      return {
        searchName: '',
        error_type: 0,
        error_content:'',/*错误内容*/
        popul:this.$route.query.popul, // 登录遮罩
        userNameTxt: this.getCookie('name'),
        registerInput:{
          phone:'',//电话
          code:'',//注册验证码
          nickname:'',//昵称
          password:'',//注册密码
          passwordAgain:'',//注册确认密码
          loginPassword:'',//登录密码
          loginCode:'',//登录验证码
        },
        login_authCode:{
          sendAuthCode:true,/*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */
          auth_time:60, /*倒计时 计数器*/
          type:3,
        },
        register_authCode:{
          sendAuthCode:true,/*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */
          auth_time:60, /*倒计时 计数器*/
          type:1,
        },
        flag : 0,
      }
    },
    props: {
      navActive:{
        default: 0
      }, //当前页导航
    },
    computed: {
      logOrReg: {
        get () {
          return this.$store.state.logOrReg
        },
        set (val) {
          this.$store.state.logOrReg = val
        }
      },
      userName(){
        return this.$store.state.registerInput.phone;
      },
      ...mapState(['uuid','headUserName'])
    },
    methods: {
      go(){
          window.open("http://exam.heihehd.cn/")
      },
      ...mapMutations(['logOrRegFun','changeheadUserName']),
      changePop: function (e) {
        this.logOrRegFun(this.logOrReg = e);
        this.popul = true;
        clearInterval(this.auth_timetimer);
        this.auth_timetimer = null;
        this.cleanError();
        this.auth_time=60;
        this.restart(this.register_authCode,false);
        this.restart(this.login_authCode,false);
        this.cleanError();
        this.registerInput.phone='';
        this.registerInput.password='';
        this.registerInput.passwordAgain='';
        this.registerInput.loginCode='';
        this.registerInput.code='';
        this.registerInput.loginPassword='';
        this.auth_time=60;
        this.restart(this.register_authCode,false);
        this.restart(this.login_authCode,false)
      },
      //搜索课程
      searchFun(){
        if(this.searchName  == ''){
          this.$toast.center('请输入搜索内容');
        }else{
          this.$router.push({
            path: `/list-search`,
            query: {name: this.searchName},
          })
        }
      },
      /*清除错误样式*/
      cleanError:function(){
        this.error_type = 0;
        this.error_content = ''
      },
      restart(e,isshow){
        e.sendAuthCode = !isshow;
        this.auth_time=this.auth_time-1;
        e.auth_time=this.auth_time
        var auth_timetimer = setTimeout(() => {
          if (this.auth_time <= 0 ||  e.sendAuthCode==true) {
            clearTimeout(this.auth_timetimer);
            e.sendAuthCode = true;
            this.flag =0
          }else {
            this.restart(e,isshow);
          }
        }, 1000);
        this.flag = 1;
      },
      //  点击获取验证码
      getAuthCode: function (e,isshow) {
        //   手机号为空
        if(this.registerInput.phone == ''){
          this.error_type = 1
          this.error_content = '请输入手机号哟！↖(￣▽￣") '
        }else{
          var that=this
          let data = {
            tel : this.registerInput.phone,
            type:e.type
          }
          axios.post('/api/Login/getCode' , data)
            .then(function (res) {
              /** 成功 : 1 **/
              if (res.data.code == 200&&that.flag == 0) {
                that.auth_time=60;
                that.restart(e,isshow);
                that.error_content=res.data.msg;
              }
              /** 失败 : 0/3 **/
              else {
                /** 提示错误信息 : 0  **/
                if (res.data.code == 400) {
                  that.error_content=res.data.msg;
                }
              }
            })
        }
      },
      //关闭弹窗
      closePop () {
        var that=this;
        that.popul=true
        that.$router.push({
          path: `/`,
        });
        that.popul = false;
        that.cleanError();
        that.registerInput.phone='';
        that.registerInput.password='';
        that.registerInput.passwordAgain='';
        that.registerInput.loginCode='';
        that.registerInput.code='';
        that.registerInput.loginPassword='';
        that.auth_time=60;
        that.restart(that.register_authCode,false);
        that.restart(that.login_authCode,false)
      },
      // 打印出我们储存的电话号码
      telInputFun: function () {
        console.log(this.registerInput.phone)
      },
      /*检查两次密码是否一致*/
      checkPassword:function () {
        if( this.registerInput.password != this.registerInput.passwordAgain){
          this.error_type = 5;
          this.error_content='两次密码输入不一致'
        }
      },
      togoOnlineClass(){
        this.$router.push({
          path:'/online_class',
          query: {
            parent_id:1,
          },
        })
      },
      isOpenFun (num) {
        if(num == 'grade'){
          this.switchOpen.grade = !this.switchOpen.grade
        }
      }, //展开
      /* 获取cookie */
      getCookie: function (name) {
        var arr = document.cookie.match(new RegExp("(^| )"+name+"=([^;]*)(;|$)"));
        if(arr != null) {
          return unescape(arr[2]);
        }
        return null;
      },
      /*注册事件*/
      register:function(){
        let that = this;
        that.popul=true
        that.$router.push({
          path: `/`,
        });
        let data = {
          tel : this.registerInput.phone,
          password:this.registerInput.password,
          repassword:this.registerInput.passwordAgain,
          code:this.registerInput.code,
        };
        axios.post('/api/Login/register', data)
          .then(function (res) {
            console.log('aaaa',res.data);
            if (res.data.code == 200) {
              that.$toast.center('注册成功');
              that.changePop(1);
            }else {
              if (res.data.code == 400) {
                that.error_content = res.data.msg
              }
            }
          })
          .catch(function (error) {
            that.error_content = error
          });
      },
      /*登录事件*/
      loginFun:function(){
        let that = this;
        that.popul=true
        that.$router.push({
          path: `/`,
        });
        let data = {
          tel:this.registerInput.phone,
          password:this.registerInput.loginPassword,
          type:1
        };
        axios.post('/api/Login/login', data)
          .then(function (res) {
            if (res.data.code == 200) {
              that.$store.commit("changeUuid", res.data.user_id);
              that.popul=false;
              //保证刷新以后 登陆的手机号仍在上边显示
              that.changeheadUserName(that.registerInput.phone);
            }if (res.data.code == 400){
              that.error_content = res.data.msg
            }else{
              that.error_content = ''
            }
          })
          .catch(function (error) {
            that.error_content = error
          });
      },
      /*验证码登录/注册*/
      authCode_login:function(){
        let that = this;
        that.popul=true
        that.$router.push({
          path: `/`,
        });
        let data = {
          tel : this.registerInput.phone,
          code : this.registerInput.loginCode,
          type:2
        };
        axios.post('/api/Login/login', data)
          .then(function (res) {
            if (res.data.code == 200) {
              that.$store.commit("changeUuid", res.data.user_id);
              that.popul=false;
              that.changeheadUserName(that.registerInput.phone);
            } else {
              that.error_content = res.data.msg
            }
          })
          .catch(function (error) {
            that.error_content = error
          });
      },
      /* 退出登录 */
      logoutFun () {
        this.logOrRegFun(this.logOrReg = 1);
        let that = this;
        that.popul = true;
        that.registerInput.phone='';
        that.registerInput.password='';
        that.registerInput.passwordAgain='';
        that.registerInput.loginCode='';
        that.registerInput.code='';
        that.registerInput.loginPassword='';
        that.changeheadUserName('');
        document.cookie = 'uuid' + "=" + '' ;
        document.cookie = 'name' + "=" + '' ;
        that.$store.commit("changeUuid", '');
        that.$store.commit("changeuserName", that.getCookie('name'));

        that.$router.push({
          path: `/`,
          query:{
           logOrReg :1,
           popul:true
          }
        });
      },
      togoUser(){
        if(this.$store.state.uuid==''){
          this.$toast.center('请先登录！')
        }else{
          this.$router.push({
            path: `/user/userInfo`,
          })
        }
      },
      togoUsers(){
        if(this.$store.state.uuid==''){
          this.$toast.center('请先登录！')
        }else{
          this.$router.push({
            path: `/zs`,
          })
        }
      },
      //获取条款链接
      toTerms(e){
        this.$router.push({
          path:'/term',
          query: {
            id: e
          }
        })
      },
      //跳转到客服
      togoTel(e){
        this.$router.push({
          path: `/service`,
        })
      }
    },
    mounted() {
      let userName = this.getCookie('name');
      this.$store.commit("changeuserName",userName)
    }
  }
</script>

<style scoped>
  .nav {
    background: #fff;
  }

  .welcome {
    width: 100%;
    height: 40px;
    background: #ededed;
    border-bottom: 1px solid #e4e4e4;
  }

  .welcome-box {
    width: 1220px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    line-height: 40px;
  }

  .welcome-box .txt {
    font-size: 14px;
    color: #8e8e8e;
  }

  .welcome-box .txt-link a {
    font-size: 14px;
    color: #8e8e8e;
    padding: 0 19px;
  }

  .txt-link {
    position: relative;
  }

  .user-menu {
    position: absolute;
    background: #fff;
    min-width: 110px;
    border: 1px solid #e4e4e4;
    text-align: center;
    border-top: none;
    z-index: 9;
    left: 0;
    right: 0;
  }

  .user-menu p {
    line-height: 45px;
    color: #969696;
    font-size: 14px;
    border-bottom: 1px solid #e4e4e4;
    cursor: pointer;
  }

  .user-menu p:hover {
    background: #ececec;
  }

  .user-menu p:last-child {
    border-bottom: none;
  }

  .welcome-box .txt-link .login-txt {
    color: #1970ff;
  }

  .down-arrow-icon {
    width: 11px;
    display: inline-block;
    position: relative;
    left: 6px;
  }

  .up-arrow-icon {
    width: 11px;
    display: inline-block;
    position: relative;
    left: 6px;
    transform: rotate(180deg);
  }

  .login-txt {
    text-align: center;
    line-height: 40px;
    display: inline-block;
  }

  .login-txt.active {
    background: #fff;
    border: 1px solid #e4e4e4;
    border-top: none;
    border-bottom: none;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .3);
    z-index: 99;
  }

  .wrapper {
    width: 433px;
    padding: 15px 26px 20px 26px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 5px;
    position: fixed;
    top:15%;
    left: 50%;
    margin-left: -216px;
  }

  .close_wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex-direction: row-reverse;
  }

  .back {
    cursor: pointer;
  }

  .close {
    cursor: pointer;
  }

  .title {
    width: 100%;
    text-align: center;
    color: #1e1e1e;
    font-size: 24px;
    padding: 10px 0;
    font-weight: 400;
  }

  .main {
    width: 100%;
  }

  .item {
    margin: 30px 0;
    width: 100%;
    height: 50px;
    position: relative;
  }

  .item img {
    position: absolute;
    top: 15px;
    left: 17px;
  }

  .code_btn {
    color: #b5b5b5;
    font-size: 16px;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    height: 50px;
    padding: 0 10px;
    display: flex;
    align-items: center;
  }

  .item input {
    width: 100%;
    height: 100%;
    padding: 16px 50px;
    box-sizing: border-box;
    border-radius: 5px;
    font-size: 16px;
    border: 1px solid #b5b5b5;
  }

  .item input:focus {
    border: 1px solid #1970ff;
    outline: #1970ff auto 0;
  }

  .item input::placeholder {
    color: #b5b5b5;
  }

  .login_btn {
    width: 100%;
    height: 50px;
    background-color: #1970ff;
    border-radius: 5px;
    color: #fff;
    font-size: 18px;
    text-align: center;
    margin: 10px 0 20px 0;
    border: 0;
    cursor: pointer;
  }

  .login_btn:focus {
    outline: #1970ff auto 0;
  }

  .other_btn {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: #959595;
    cursor: pointer;
  }

  .user_agreement {
    display: flex;
    justify-content: flex-start;
    color: #b5b5b5;
  }

  .high_light {
    color: #1970ff;
  }

  .item .error_active {
    border: 1px solid #1970ff;
  }

  .error_content {
    margin: 0 0 20px 0;
    color: #ff0000;
  }
  .city-search{
    width: 1220px;
    margin: 25px auto 0;
    display: flex;
    padding-bottom: 10px;
    justify-content: space-between;
  }
  .logo{
    width: 224px;
  }
  .choose-city{
    cursor: pointer;
  }
  .city span{
    color: #2a2a2a;
    font-size: 16px;
    margin-left: 28px;
    line-height: 50px;
    cursor: pointer;
  }
  .down-triangle{
    border: 7px solid transparent;
    border-top-color: #000;
    line-height: 85px;
    margin-left: 10px;
  }
  .select-city-box{
    width: 100%;
    padding: 10px 17px;
    box-sizing: border-box;
  }
  .letter{
    color: #1970ff;
    font-size: 16px;
    display: inline-block;
    font-weight: bold;
    vertical-align: top;
    position: relative;
    top: 5px;
  }
  .select-city-item-list{
    display: inline-block;
    width: 97%;
  }
  .select-city-item-list li{
    display: inline-block;
    margin-left: 15px;
    margin-bottom: 20px;
    padding: 5px 5px 3px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .select-city-item-list li.active{
    color: #fff;
    background: #1970ff;
    border-radius: 4px;
  }
  .select-city-item{
    margin-bottom: 10px;
  }
  .search{
    width: 278px;
    border: 2px solid #1970ff;
    height: 42px;
    position: relative;
  }
  .search-input{
    color: #bbb;
    font-size: 16px;
    padding-left: 8px;
    padding-right: 16px;
    box-sizing: border-box;
    width: 207px;
    height: 42px;
    position: absolute;
    left: 0;
    border:none;
  }
  .search-input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    color: #bbb;
    font-size:16px;
  }

  　　.search-input:-moz-placeholder, textarea:-moz-placeholder {
    　color: #bbb;
    font-size:16px;
  }

  .search-input::-moz-placeholder, textarea::-moz-placeholder {
    color: #bbb;
    font-size:16px;
  }

  .search-input:-ms-input-placeholder, textarea:-ms-input-placeholder {
    color: #bbb;
    font-size:16px;
  }
  .reading_glass{
    width: 78px;
    height: 42px;
    background: #1970ff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    line-height: 39px;
    text-align: center;
    cursor: pointer;
  }
  .tell{
    font-size: 22px;
    color: #1970ff;
    font-weight: bold;
    line-height: 54px;
  }
  .tell span{
    margin-left: 10px;
  }
  .city .active{
    color: #1970ff;
    border-bottom: 4px solid #1970ff;
    padding-bottom:8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/welcome-nav.vue